import type { RouteObject } from 'react-router-dom';
import { ShippingAddressListPage } from './pages/ShippingAddressListPage';
import { ShippingAddressNewPage } from './pages/ShippingAddressNewPage';
import { ShippingAddressEditPage } from './pages/ShippingAddressEditPage';

export const shippingRoutes: RouteObject[] = [
  {
    index: true,
    element: <ShippingAddressListPage />,
  },
  {
    path: 'new',
    element: <ShippingAddressNewPage />,
  },
  {
    path: ':slug',
    element: <ShippingAddressEditPage />,
  },
];
